<template>
  <v-container fluid class="schedule-dashboard pa-4 pa-md-6">
    <v-card flat class="schedule-header-card mb-4">
      <v-card-text class="d-flex align-center pa-4">
        <div class="schedule-header-icon mr-3">
          <v-icon size="24" color="white">mdi-calendar-clock</v-icon>
        </div>
        <div>
          <div class="schedule-title">ปฏิทินกำหนดการเปิด-ปิดระบบ</div>
          <div class="schedule-subtitle grey--text text--darken-1">
            รวมทุกกำหนดการที่ต้องดำเนินการ จัดกลุ่มตามผู้เกี่ยวข้อง
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-tabs v-model="activeTab" background-color="transparent" class="schedule-tabs" show-arrows>
      <v-tab v-for="cat in categories" :key="cat.key">
        <v-icon left small>{{ cat.icon }}</v-icon>
        {{ cat.label }}
        <v-chip
          v-if="counts[cat.key] > 0"
          x-small
          class="ml-2 tab-count-chip"
          :color="cat.color"
          text-color="white"
        >
          {{ counts[cat.key] }}
        </v-chip>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab" class="schedule-tab-items">
      <v-tab-item eager>
        <div v-if="counts.personnel === 0" class="empty-state">
          <v-icon size="40" color="grey lighten-1">mdi-calendar-check-outline</v-icon>
          <p class="grey--text mt-2">ไม่มีกำหนดการที่เกี่ยวกับบุคลากรในขณะนี้</p>
        </div>
        <alert_personnel_report_rounds />
        <AlertMissionPersonnelAssTeach_license ref="license" />
        <AlertMissionReportAssistant ref="reportAssistant" />
        <alertMissionPersonnelAssTeach ref="assTeach" />
        <alertMissionPersonnelDirector ref="director" />
        <alertMissionPersonnelTeach ref="teach" />
        <AlertMissionPersonnelGovem ref="govem" />
      </v-tab-item>

      <v-tab-item eager>
        <div v-if="counts.college === 0" class="empty-state">
          <v-icon size="40" color="grey lighten-1">mdi-calendar-check-outline</v-icon>
          <p class="grey--text mt-2">ไม่มีกำหนดการที่เกี่ยวกับสถานศึกษา/สถาบันในขณะนี้</p>
        </div>
        <AlertMissionCollege ref="college" />
      </v-tab-item>

      <v-tab-item eager>
        <div v-if="counts.province === 0" class="empty-state">
          <v-icon size="40" color="grey lighten-1">mdi-calendar-check-outline</v-icon>
          <p class="grey--text mt-2">ไม่มีกำหนดการที่เกี่ยวกับ สอจ./จังหวัดในขณะนี้</p>
        </div>
        <alertMissionProvince ref="province" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import AlertMissionCollege from "./alertMissionCollege.vue";
import alertMissionPersonnelAssTeach from "./alertMissionPersonnelAssTeach.vue";
import alertMissionPersonnelDirector from "./alertMissionPersonnelDirector.vue";
import alertMissionPersonnelTeach from "./alertMissionPersonnelTeach.vue";
import alertMissionProvince from "./alertMissionProvince.vue";
import AlertMissionPersonnelGovem from "./alertMissionPersonnelGovem.vue";
import AlertMissionReportAssistant from "./alertMissionReportAssistant.vue";
import AlertMissionPersonnelAssTeach_license from "./alertMissionPersonnelAssTeach_license.vue";
import alert_personnel_report_rounds from "../college/alert_personnel_report_rounds.vue";

function isOn(val) {
  return val === "1" || val === 1;
}

export default {
  name: "ScheduleDashboard",

  components: {
    AlertMissionCollege,
    alertMissionPersonnelAssTeach,
    alertMissionPersonnelDirector,
    alertMissionPersonnelTeach,
    alertMissionProvince,
    AlertMissionPersonnelGovem,
    AlertMissionReportAssistant,
    AlertMissionPersonnelAssTeach_license,
    alert_personnel_report_rounds
  },

  data() {
    return {
      activeTab: 0,
      refsReady: false,
      categories: [
        { key: "personnel", label: "บุคลากร", icon: "mdi-account-group", color: "#dc2626" },
        { key: "college", label: "สถานศึกษาและสถาบัน", icon: "mdi-town-hall", color: "#2563eb" },
        { key: "province", label: "สอจ. / จังหวัด", icon: "mdi-domain", color: "#0d9488" }
      ]
    };
  },

  mounted() {
    // $refs ยังไม่ถูกตั้งค่าตอน computed ประเมินรอบแรก (ก่อน child mount)
    // ต้องบังคับประเมินใหม่อีกครั้งหลัง child mount เพื่อให้ Vue ผูก reactivity
    // กับข้อมูลภายใน child ได้จริง ไม่งั้น badge จะค้างที่ 0 ตลอดไปแม้ child โหลดข้อมูลเสร็จ
    this.$nextTick(() => {
      this.refsReady = true;
    });
  },

  computed: {
    counts() {
      // eslint-disable-next-line no-unused-expressions
      this.refsReady;
      const license = this.$refs.license;
      const reportAssistant = this.$refs.reportAssistant;
      const assTeach = this.$refs.assTeach;
      const director = this.$refs.director;
      const teach = this.$refs.teach;
      const govem = this.$refs.govem;
      const college = this.$refs.college;
      const province = this.$refs.province;

      let personnel = 0;
      if (license && isOn(license.periodsCh && license.periodsCh.period_enable)) personnel++;
      if (reportAssistant && isOn(reportAssistant.periodassteachTeachers && reportAssistant.periodassteachTeachers.periodAssTeachEnable)) personnel++;
      if (assTeach && isOn(assTeach.periodassteachsCh && assTeach.periodassteachsCh.periodAssTeachEnable)) personnel++;
      if (director) {
        if (isOn(director.period_sedirectors_chooses && director.period_sedirectors_chooses.period_sedirector_enable)) personnel++;
        if (isOn(director.period_sedirectors && director.period_sedirectors.period_sedirector_enable)) personnel++;
        if (isOn(director.period_directors && director.period_directors.period_sedirector_enable)) personnel++;
      }
      if (teach) {
        if (teach.periodSupervision && teach.periodSupervision.period_sedirector_enable === 1) personnel++;
        if (teach.periodTeachers && teach.periodTeachers.period_enable === "1" && teach.periodTeachers.period_type === "teacher") personnel++;
      }
      if (govem && isOn(govem.periodTeachers && govem.periodTeachers.period_enable)) personnel++;

      const college_count = college ? (college.totalActiveAlerts || 0) : 0;

      let province_count = 0;
      if (province) {
        [
          "period_vecprovince_dirb",
          "period_vecprovince_ap",
          "period_vecprovince_apdir",
          "period_vecprovince_b",
          "period_vecprovinceTeacher",
          "period_vecprovincemanage"
        ].forEach((key) => {
          const obj = province[key];
          if (obj && isOn(obj.period_vecprovince_enable)) province_count++;
        });
      }

      return { personnel, college: college_count, province: province_count };
    }
  }
};
</script>

<style scoped>
.schedule-dashboard {
  max-width: 1200px;
  margin: 0 auto;
}

.schedule-header-card {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
}

.schedule-header-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0f172a, #334155);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.schedule-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.schedule-subtitle {
  font-size: 0.82rem;
  margin-top: 2px;
}

.schedule-tabs {
  border-radius: 12px;
  margin-bottom: 8px;
}

.tab-count-chip {
  font-weight: 700 !important;
}

.schedule-tab-items {
  background: transparent !important;
}

.empty-state {
  text-align: center;
  padding: 48px 16px;
}
</style>

<!--
  คลาสมาตรฐานร่วมสำหรับการ์ดแจ้งเตือนกำหนดการทั้งหมด (ไม่ scoped โดยตั้งใจ)
  ใช้ prefix "hrvec-" เพื่อไม่ชนกับ class อื่นในแอป — อ้างอิงจาก AlertMissionCollege.vue
  ที่เป็นดีไซน์มาตรฐานล่าสุด ให้ทุก alertMission* component ใช้ร่วมกันแทนการประกาศ CSS ซ้ำ
-->
<style>
.hrvec-alert-card {
  border-radius: 14px !important;
  border: 1px solid #e2e8f0 !important;
  position: relative;
  overflow: hidden;
  transition: all 0.25s ease;
  background: #ffffff !important;
}

.hrvec-alert-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06) !important;
}

.hrvec-priority-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  z-index: 1;
}

.hrvec-priority-bar.urgent { background: #dc2626; }
.hrvec-priority-bar.high   { background: #f59e0b; }
.hrvec-priority-bar.normal { background: #3b82f6; }

.hrvec-card-content-col {
  padding: 20px 16px 20px 24px;
}

.hrvec-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.hrvec-card-title {
  font-size: 0.98rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.45;
  margin: 0;
}

.hrvec-card-subtitle {
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 400;
  line-height: 1.4;
}

.hrvec-badge-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.hrvec-detail-note {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: #475569;
  margin-bottom: 4px;
  line-height: 1.4;
}

.hrvec-warning-note {
  color: #92400e;
  font-weight: 500;
}

.hrvec-action-button {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  letter-spacing: 0 !important;
  padding: 0 20px !important;
  height: 38px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.hrvec-card-countdown-col {
  padding: 16px 20px 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hrvec-card-countdown {
  text-align: center;
  padding: 16px 20px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  width: 100%;
}

.hrvec-countdown-label {
  font-size: 0.72rem;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}

.hrvec-countdown-date {
  font-size: 0.88rem;
  font-weight: 700;
  color: #dc2626;
}

.hrvec-countdown-flip-wrap {
  display: flex;
  justify-content: center;
}

.hrvec-countdown-flip-wrap .flip-countdown {
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

.hrvec-countdown-flip-wrap .flip-countdown__piece {
  background: #1e293b !important;
  color: white !important;
  border-radius: 8px !important;
  font-weight: 700 !important;
  font-size: 1.1rem !important;
  min-width: 48px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.hrvec-countdown-flip-wrap .flip-countdown__slot {
  font-size: 0.68rem !important;
  color: #94a3b8 !important;
  margin-top: 4px !important;
  font-weight: 600 !important;
}

@media (max-width: 960px) {
  .hrvec-card-countdown-col { padding: 0 20px 20px 24px; }
}

@media (max-width: 600px) {
  .hrvec-icon-wrap { width: 36px; height: 36px; }
  .hrvec-card-title { font-size: 0.9rem; }
}
</style>
